import { ReduxService } from 'dashboard-services/services';

import { chartCustomInsightActions } from 'actions/modules/insight';

export const chartCustomReducer = (state, action) => {
  switch (action.type) {
    case chartCustomInsightActions.ADD_AXIS_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            [action.right ? 'rightAxis' : 'leftAxis']: ReduxService.updateObject(state.content.tiles[action.index][action.right ? 'rightAxis' : 'leftAxis'], {
              data: state.content.tiles[action.index][action.right ? 'rightAxis' : 'leftAxis'].data.add(action.data)
            })
          }, action.index)
        })
      })
    case chartCustomInsightActions.REMOVE_AXIS_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            [action.right ? 'rightAxis' : 'leftAxis']: ReduxService.updateObject(state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'], {
              data: state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'].data.remove(action.dataIndex)
            })
          }, action.tileIndex)
        })
      })
    case chartCustomInsightActions.REORDER_AXIS_DATA: {
      if(action.to === action.from || action.to === -1 || action.from === -1) {
        return state;
      }
      const referenceToList = state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'].data
      const item = referenceToList[action.from]
      let list
      if(action.from > action.to) {
        list = referenceToList.slice(0, action.to)
        list = list.concat([item])
        list = list.concat(referenceToList.slice(action.to, action.from))
        list = list.concat(referenceToList.slice(action.from + 1))
      } else {
        list = referenceToList.slice(0, action.from)
        if(action.from + 1 < action.to) {
          list = list.concat(referenceToList.slice(action.from + 1, action.to))
        }
        list = list.concat(referenceToList.slice(action.to, action.to + 1)).concat([item]).concat(referenceToList.slice(action.to + 1))
      }
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            [action.right ? 'rightAxis' : 'leftAxis']: ReduxService.updateObject(state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'], {
              data: list
            })
          }, action.tileIndex)
        })
      })
    }
    case chartCustomInsightActions.DUPLICATE_AXIS_DATA:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            [action.right ? 'rightAxis' : 'leftAxis']: ReduxService.updateObject(state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'], {
              data: state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'].data.add(ReduxService.updateObject({}, state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'].data[action.dataIndex]), action.dataIndex + 1)
            })
          }, action.tileIndex)
        })
      })
    case chartCustomInsightActions.CHANGE_AXIS_DATA: {
      if(state.content.tiles[action.index]?.[action.right ? 'rightAxis' : 'leftAxis']?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, { 
            tiles: state.content.tiles.updateInList({
              [action.right ? 'rightAxis' : 'leftAxis']: ReduxService.updateObject(state.content.tiles[action.index][action.right ? 'rightAxis' : 'leftAxis'], {
                [action.name]: action.value
              })
            }, action.index)
          })
        })
      }
      return state;
    }
    case chartCustomInsightActions.SET_DATA_REF: {
      const arr = Array(action.index + 1).fill(0)
      state[action.dataRef].forEach((d, i) => arr[i] = d)
      return ReduxService.updateObject(state, { [action.dataRef]: arr.replace(action.value, action.index) })
    }
    case chartCustomInsightActions.CHANGE_ELEMENT_IN_AXIS_DATA: {
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            [action.right ? 'rightAxis' : 'leftAxis']: ReduxService.updateObject(state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'], {
              data: state.content.tiles[action.tileIndex][action.right ? 'rightAxis' : 'leftAxis'].data.updateInList({ [action.name]: action.value }, action.dataIndex)
            })
          }, action.tileIndex)
        })
      })
    }
    case chartCustomInsightActions.ADD_CONDITIONAL_FORMATTING: 
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          tiles: state.content.tiles.updateInList({ 
            conditionalFormatting: (state.content.tiles[action.index].conditionalFormatting || []).add(action.data)
          }, action.index),
        })
      })
    case chartCustomInsightActions.REMOVE_CONDITIONAL_FORMATTING:
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList({
            conditionalFormatting: state.content.tiles[action.tileIndex].conditionalFormatting.remove(action.conditionalFormattingIndex),
          }, action.tileIndex)
        })
      })
    case chartCustomInsightActions.CHANGE_CONDITIONAL_FORMATTING: {
      if(state.content.tiles[action.tileIndex]?.conditionalFormatting?.[action.conditionalFormattingIndex]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, {
            tiles: state.content.tiles.updateInList({
              conditionalFormatting: state.content.tiles[action.tileIndex].conditionalFormatting.updateInList({
                [action.name]: action.value
              }, action.conditionalFormattingIndex)
            }, action.tileIndex)
          })
        })
      }
      return state;
    }
    case chartCustomInsightActions.CHANGE_TOOLTIP_CONFIG: {
      if(state.content.tiles[action.tileIndex].tooltipConfig?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, {
            tiles: state.content.tiles.updateInList({
              tooltipConfig: (state.content.tiles[action.tileIndex].tooltipConfig || []).updateInList({
                [action.name]: action.value
              }, action.tooltipIndex)
            }, action.tileIndex)
          })
        })
      }
      return state;
    }
    default:
      return undefined;
  }
}